export const goalNum = 200000;
